'use client';

import { useEffect } from 'react';

export default function ScrollToHash() {
  useEffect(() => {
    const handleScroll = () => {
      const hash = window.location.hash;
      if (!hash) return;

      const element = document.querySelector(hash);
      if (!element) return;

      // Delay until everything fully rendered
      requestAnimationFrame(() => {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: 'auto',
            block: 'start',
          });
        }, 500);
      });
    };

    handleScroll();

    window.addEventListener('load', handleScroll);

    return () => {
      window.removeEventListener('load', handleScroll);
    };
  }, []);

  return null;
}
